import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** "project" / "projects" — the word alone, for when the number is rendered separately. */
export function pluralWord(n: number, word: string, suffix = 's'): string {
  return `${word}${n === 1 ? '' : suffix}`
}

/** "1 project" / "2 projects" — regular pluralization (append `suffix` unless n === 1). */
export function plural(n: number, word: string, suffix = 's'): string {
  return `${n} ${pluralWord(n, word, suffix)}`
}
